import React from 'react'
import {connect} from 'react-redux'
import {wrapDispatch} from 'multireducer'
import {SecondaryButton} from '../../unilink/index'
import {pauseContinue} from '../../../../redux/modules/content'
import './pause.css'

const Pause = ({className, pauseContinue, index, content}) => {
  const classNames = ['pause-content']
  if (className) {
    classNames.push(className)
  }
  if (!content.shouldContinue) {
    return (
      <div className={classNames.join(' ')}>
        <SecondaryButton onClick={()=>pauseContinue(index)}>Continue</SecondaryButton>
      </div>
    )
  } else {
    return null
  }

}

const mapDispatchToProps = (dispatch,{as}) => {
  return {
    pauseContinue: blockIndex => {
      wrapDispatch(dispatch, as)(pauseContinue(blockIndex))
    }
  }
}

const VisiblePause = connect(
  null,
  mapDispatchToProps
)(Pause)

export default VisiblePause



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/pause/Pause.js